// extracted by mini-css-extract-plugin
export var actions = "_qm-5";
export var assistantBubble = "_qm-3";
export var assistantRow = "_qm-6";
export var bubble = "_qm-0";
export var humanAvatar = "_qm-4";
export var inlineToolCard = "_qm-1";
export var userBubble = "_qm-2";